import React, { useEffect, useRef, useState } from 'react'
import StatusCard from '../../../../component/status-card/status-card'
import DateRangePicker from '../../../../component/date-range-picker/DateRangePicker'
import { useHistory } from 'react-router-dom'
import {
  message,
  Button,
  Col,
  Card,
  ConfigProvider,
  Layout,
  Pagination,
  Popconfirm,
  Row,
  Statistic,
  Table,
  Tag,
} from 'antd'
import * as echarts from 'echarts/core'
import {
  TooltipComponent,
  TooltipComponentOption,
  LegendComponent,
  LegendComponentOption,
} from 'echarts/components'
import { PieChart, PieSeriesOption } from 'echarts/charts'
import { LabelLayout } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'

import ClusterStyle from './cluster-manager.module.less'
import './cluster.css'
export interface Props {
  mode:string;
}

const ClusterManager: React.FC<Props> = (props) => {
  const { mode } = props;
  const history = useHistory();
  const [CPUused, setCPUused] = useState(10)
  const [CPUtotal, setCPUtotal] = useState(320)

  const [RAMused, setRAMused] = useState(10)
  const [RAMtotal, setRAMtotal] = useState(320)
  const [nodeList, setNodeList] = useState([
    {
      node_name: 'name-node-2:33798',
      http: 'name-node-2:8042',
      node_RAM: 64,
      use_RAM: 20,
      last_runned: '2022 9/16 10:30',
      node_status: 'running',
    },
    {
      node_name: 'name-node-2:33798',
      http: 'name-node-2:8042',
      node_RAM: 64,
      use_RAM: 20,
      last_runned: '2022 9/16 10:30',
      node_status: 'running',
    },
    {
      node_name: 'name-node-2:33798',
      http: 'name-node-2:8042',
      node_RAM: 64,
      use_RAM: 20,
      last_runned: '2022 9/16 10:30',
      node_status: 'running',
    },
    {
      node_name: 'name-node-2:33798',
      http: 'name-node-2:8042',
      node_RAM: 64,
      use_RAM: 20,
      last_runned: '2022 9/16 10:30',
      node_status: 'running',
    },
    {
      node_name: 'name-node-2:33708',
      http: 'name-node-2:8042',
      node_RAM: 64,
      use_RAM: 20,
      last_runned: '2022 9/16 10:30',
      node_status: 'running',
    },
  ])

  const statusCard = useRef([
    {
      type: 'running',
      label: '运行中',
      num: 30,
    },
    {
      type: 'success',
      label: '成功',
      num: 30,
    },
    {
      type: 'failed',
      label: '失败',
      num: 30,
    },
    {
      type: 'stoped',
      label: '已停止',
      num: 30,
    },
    {
      type: 'queueing',
      label: '排队中',
      num: 30,
    },
  ])

  echarts.use([
    TooltipComponent,
    LegendComponent,
    PieChart,
    CanvasRenderer,
    LabelLayout,
  ])

  useEffect(() => {
    //   cpu charts
    const CPUChartsOptions = {
      tooltip: {
        trigger: 'item',
        formatter: (params) => {
          let res = `<div class="charts-tooltip"><p>${params.data.label}：${
            params.data.value
          }G</p><p>(${Math.floor(
            (params.data.value / params.data.total) * 100
          )}%)</p></div>`
          return res
        },
        extraCssText:
          'padding:5px 10px 5px 10px;display:flex;flex-direction:column;width:90px; min-height:42px; border:none; background-color: #3c85ff; border-radius: 8px; color: #fff; text-align: center; font-size:12px;',
      },
      color: ['#3c85ff', '#9f6af5'],
      legend: {
        top: '5%',
        left: 'center',
      },
      toolbox: {
        y: -30,
        show: true,
        feature: {
          dataView: false,
        },
      },
      series: [
        {
          name: 'CPU',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          emphasis: {
            label: {
              show: false,
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: CPUused, label: '已使用', total: CPUtotal },
            { value: CPUtotal - CPUused, label: '剩余', total: CPUtotal },
          ],
        },
      ],
    }
    const CPUChartsDom: HTMLElement = document.getElementById('charts-cpu')!
    const CPUCharts = echarts.init(CPUChartsDom)
    let CPUChartsOpts: any = CPUChartsOptions
    CPUChartsOpts && CPUCharts.setOption(CPUChartsOpts)

    //  RAM charts
    const RAMChartsOptions = {
      tooltip: {
        trigger: 'item',
        formatter: (params) => {
          let res = `<div class="charts-tooltip"><p>${params.data.label}：${
            params.data.value
          }</p><p>(${Math.floor(
            (params.data.value / params.data.total) * 100
          )}%)</p></div>`
          return res
        },
        extraCssText:
          'padding:5px 10px 5px 10px;display:flex;flex-direction:column;width:90px; min-height:42px; border:none; background-color: #3c85ff; border-radius: 8px; color: #fff; text-align: center; font-size:12px;',
      },
      color: ['#3c85ff', '#9f6af5'],
      legend: {
        top: '5%',
        left: 'center',
      },
      toolbox: {
        y: -30,
        show: true,
        feature: {
          dataView: false,
        },
      },
      series: [
        {
          name: 'RAM',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          emphasis: {
            label: {
              show: false,
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: RAMused, label: '已使用', total: RAMtotal },
            { value: RAMtotal - RAMused, label: '剩余', total: RAMtotal },
          ],
        },
      ],
    }
    const RAMChartsDom: HTMLElement = document.getElementById('charts-ram')!
    const RAMCharts = echarts.init(RAMChartsDom)
    let RAMChartsOpts: any = RAMChartsOptions
    RAMChartsOpts && RAMCharts.setOption(RAMChartsOpts)
  }, [])

  const gotoClusterDetail =()=>{
    if(mode == "oam")
      history.push("/oam_cluster_detail")
    if(mode == "college-oam")
      history.push("/college-oam/cluster_detail")
  }

  return (
      <Card
        title={'集群监控'}
        extra={<Button onClick={gotoClusterDetail} type={'primary'}>查看监控详情</Button>}
        style={mode === "oam" ? { width: '100%', margin: 20, borderRadius: 10,overflow:'hidden'} : mode === "college-oam" ? { width: '97%', margin: 20, borderRadius: 10,overflow:'hidden'}:{}}
      >
        <Row>
          {/*charts*/}
          <Col span={9}>
            <div className={ClusterStyle.chartsBox}>
              <Row>
                <Col span={12}>
                  <div className={ClusterStyle.chartsTitle}>CPU</div>
                  <div id={'charts-cpu'}></div>
                  <div className={ClusterStyle.chartsInfo}>
                    <span>已使用/全部</span>
                    <span>
                      {CPUused} / {CPUtotal}(G)
                    </span>
                  </div>
                </Col>
                <Col span={12}>
                  <div className={ClusterStyle.chartsTitle}>内存</div>
                  <div id={'charts-ram'}></div>
                  <div className={ClusterStyle.chartsInfo}>
                    <div className={ClusterStyle.chartsInfo}>
                      <span>已使用/全部</span>
                      <span>
                        {CPUused} / {CPUtotal}(G)
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          {/*status box*/}
          <Col span={15}>
            <div className={ClusterStyle.statusBox}>
              <Row>
                <Col span={11}>
                  <div className={ClusterStyle.statusTitle}>提交任务</div>
                </Col>
                <Col
                  span={12}
                  style={{ marginTop: 10, textAlign: 'right', marginLeft: 10 }}
                >
                  <DateRangePicker mode={'oam'} />
                </Col>
              </Row>
              <div className={ClusterStyle.statusCardBox}>
                {statusCard.current?.map((card, index) => {
                  return (
                    <StatusCard
                      type={card.type}
                      mode={'oam'}
                      label={card.label}
                      num={card.num}
                      key={index}
                    />
                  )
                })}
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <div className={ClusterStyle.nodeListBox}>
              <div className={ClusterStyle.statusTitle}>节点信息</div>
              <div className={ClusterStyle.nodeList}>
                {nodeList.map((node, index) => {
                  return (
                    <div className={ClusterStyle.nodeInfo} key={index}>
                      <div className={ClusterStyle.nodeInfoContain}>
                        <div className={ClusterStyle.nodeInfoTitle}>
                          {node.node_name}
                        </div>
                        <Row className={ClusterStyle.nodeInfoItem}>
                          <Col span={8}>Http</Col>
                          <Col span={16}>{node.http}</Col>
                        </Row>
                        <Row className={ClusterStyle.nodeInfoItem}>
                          <Col span={8}>节点内存</Col>
                          <Col span={16}>{node.node_RAM}GB</Col>
                        </Row>
                        <Row className={ClusterStyle.nodeInfoItem}>
                          <Col span={8}>使用内存</Col>
                          <Col span={16}>{node.use_RAM}GB</Col>
                        </Row>
                        <Row className={ClusterStyle.nodeInfoItem}>
                          <Col span={8}>上次运行</Col>
                          <Col span={16}>{node.last_runned}</Col>
                        </Row>
                        <Row className={ClusterStyle.nodeInfoItem}>
                          <Col span={8}>节点状态</Col>
                          <Col span={16}>
                            {node.node_status === 'running' ? (
                              <Tag color={'#669efb'}>运行中</Tag>
                            ) : (
                              ''
                            )}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </Col>
        </Row>
      </Card>
  )
}

export default ClusterManager
